import { render, staticRenderFns } from "./ReporteDetalleValidaciones.vue?vue&type=template&id=572fc412&scoped=true&"
import script from "./ReporteDetalleValidaciones.vue?vue&type=script&lang=js&"
export * from "./ReporteDetalleValidaciones.vue?vue&type=script&lang=js&"
import style0 from "./ReporteDetalleValidaciones.vue?vue&type=style&index=0&id=572fc412&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "572fc412",
  null
  
)

export default component.exports